import { render, staticRenderFns } from "./NormalSearchNav225.vue?vue&type=template&id=2a89b852&scoped=true&"
import script from "./NormalSearchNav225.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav225.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89b852",
  null
  
)

export default component.exports